module.exports = __webpack_public_path__ + "static/assets/7b6005b2e645dae280804d300e62201d.png";